import type { InputPuzzle } from "./puzzle.types";

export const MASTER_PUZZLES: InputPuzzle[] = [
  {
    p: "000000905860000030709030100000070800000862001000100092600000043000200000051000009",
    s: "123647985865921437749538126512379864974862351386154792698715243437296518251483679",
    d: 54000000,
  },
  {
    p: "000057000500030020780000053000002008308060000040700000001000240000200109036010000",
    s: "123957864569834721784621953915342678378165492642798315891573246457286139236419587",
    d: 54000000,
  },
  {
    p: "004000000060000000078000014000000290000170000002800500040069000000005307000080026",
    s: "124658739963741852578923614716534298895172463432896571247369185689215347351487926",
    d: 54000000,
  },
  {
    p: "100000900000046570000003020050004000009500000040060002000000008000025100800009340",
    s: "124758936983246571765193824257384619619572483348961752591437268436825197872619345",
    d: 54000000,
  },
  {
    p: "000000000070810000304090010200000487000060005003000001061089000000530020000000048",
    s: "125347869679812354384695712216953487948761235753428691461289573897534126532176948",
    d: 54000000,
  },
  {
    p: "000400600068070000000000908600000712300120000000000000503060470700500020001009000",
    s: "125498637968375241437612958659843712374126895812957364583261479796584123241739586",
    d: 54000000,
  },
  {
    p: "100000300600000004004080700000500002003400000406900030500810600070090020000070900",
    s: "125749386687153294934286715798531462213467859456928137549812673371694528862375941",
    d: 54000000,
  },
  {
    p: "000000607067002000003000800472600010000000300500009000000050020010000090050400708",
    s: "125894637867532941943167852472683519698215374531749286784956123216378495359421768",
    d: 54000000,
  },
  {
    p: "020000800840001000300700040000000000030000502600940070000017004008060000900000103",
    s: "126495837847631259395728641289573416734186592651942378563217984418369725972854163",
    d: 54000000,
  },
  {
    p: "020000000000600000980054320600090008001080000008006030710520900400000507000000000",
    s: "126839475345672891987154326634291758271385649598746132713528964462913587859467213",
    d: 54000000,
  },
  {
    p: "100304000000000705005020000300000150080010040000008300009000630072000000000900080",
    s: "127354869438169725965827413394276158786513942251498376549782631872631594613945287",
    d: 54000000,
  },
  {
    p: "000008009050020070063007000002600050700000003006005004000400007200300400000050012",
    s: "127568349458923176963147528892634751745891263316275984589412637271386495634759812",
    d: 54000000,
  },
  {
    p: "000090036000000000480000100009400007050300068060700000005070010241800000000006000",
    s: "127598436593614782486237195819465327754321968362789541635972814241853679978146253",
    d: 54000000,
  },
  {
    p: "007050004080401000903800000360508040000030005000004090600700430700000000039000067",
    s: "127953684586471923943862571361598742294637815875124396652719438718346259439285167",
    d: 54000000,
  },
  {
    p: "100070000400603000000000784060001502700809600000000008200300000004010060096004030",
    s: "129478356487653921653192784368741592745829613912536478271365849834917265596284137",
    d: 54000000,
  },
  {
    p: "000400500000060000604000100000700062500000300403009000090020000200031680000006050",
    s: "129487536735162948684395127918753462572648391463219875896524713257931684341876259",
    d: 54000000,
  },
  {
    p: "100060000007003200000000095300070580090000006005608100600007000800000000910200070",
    s: "129865347587493261436721895361972584298514736745638129654387912872149653913256478",
    d: 54000000,
  },
  {
    p: "000070000600000080400009030000090168009000000301800040800000004000032015024680000",
    s: "132578496697314582458269731245793168789146253361825947813957624976432815524681379",
    d: 54000000,
  },
  {
    p: "000000006009000027007300000004010008010608900700000060300000840020090075008050000",
    s: "132749586849561327567382491694215738213678954785934162356127849421893675978456213",
    d: 54000000,
  },
  {
    p: "030000004090000708000000200000000420200980060040060091000049000000002005580003000",
    s: "132798654496125738857436219968351427271984563345267891723549186619872345584613972",
    d: 54000000,
  },
  {
    p: "004000800000000032200700104000801000350000080600000009005004001000300060000068400",
    s: "134592876587416932296783154972851643351649287648237519865974321419325768723168495",
    d: 54000000,
  },
  {
    p: "000600900085710000000030000000400001860002000002150030000800105420000000500000009",
    s: "134628957985714362276935418359486271861372594742159836693847125427591683518263749",
    d: 54000000,
  },
  {
    p: "000008070000200400000430000083000000016002700007000058008001037040000065900003010",
    s: "134958672759216483862437591483795126516382749297164358628541937341879265975623814",
    d: 54000000,
  },
  {
    p: "100400000000006500049070002391040008000090020008300000000003810000900007070000060",
    s: "135429786782136549649875132391542678457698321268317495926753814813964257574281963",
    d: 54000000,
  },
  {
    p: "000070200500030006807000040000504600000000001005210009001305000000000800070920500",
    s: "136479285524831796897652143713594628982763451465218379241385967659147832378926514",
    d: 54000000,
  },
  {
    p: "006500700000001003020000000000000830570140090040009570010000000800200400009058000",
    s: "136592748485671923927384156691725834578143692342869571714936285853217469269458317",
    d: 54000000,
  },
  {
    p: "000000200085000007000408006010040600060200390800009010600000500090071000040900000",
    s: "136597284485126937927438156219843675764215398853769412671384529592671843348952761",
    d: 54000000,
  },
  {
    p: "000000807005000020902000006000060400200070900804000070001800003090000000000103092",
    s: "136952847745681329982734516579268431213475968864319275421897653397526184658143792",
    d: 54000000,
  },
  {
    p: "000008200000701034000003070000600000290050700658002000000000520081005307000000000",
    s: "137468295825791634469523178714639852293854716658172943346987521981245367572316489",
    d: 54000000,
  },
  {
    p: "000000900000040030089010002050004003820500100900200008000006007000835000600090300",
    s: "137652984562948731489317652756184293823579146914263578395426817271835469648791325",
    d: 54000000,
  },
  {
    p: "000090200000030840060005700001740003300060000240001000700000080020008000010006500",
    s: "137894265952637841468125739581749623379562418246381957794253186625918374813476592",
    d: 54000000,
  },
  {
    p: "130402500460350000000007004850030000001004000642080007016005000000000800000003705",
    s: "138492576467358129295167384859736412371924658642581937716845293523679841984213765",
    d: 54000000,
  },
  {
    p: "009020800000000300020980000006200080007040500300008001004000600500100000800000090",
    s: "139427856748516329625983174416235987987641532352798461274859613593162748861374295",
    d: 54000000,
  },
  {
    p: "002070000500400070000008010310000002000000807000092300800009000460000000000801460",
    s: "142375986598416273673928514315784692924163857786592341831649725469257138257831469",
    d: 54000000,
  },
  {
    p: "042706000030059180050000020000000000020004007600000908090000000000607000000035402",
    s: "142786539736259184958341726481973265529864317673512948395428671214697853867135492",
    d: 54000000,
  },
  {
    p: "000060070000400006030705084000086001050020600200900000028001000400600000075000090",
    s: "142869375587432916936715284794386521853127649261954738328591467419673852675248193",
    d: 54000000,
  },
  {
    p: "103000000000800002800090005200900400090075600070103008600020000082700900000000000",
    s: "143562789965837142827491365231986457498275631576143298619328574382754916754619823",
    d: 54000000,
  },
  {
    p: "000009300057400000200500100000170403070050600000900000005004020010008000300000009",
    s: "146289375857431962239567148928176453473852691561943287795314826612798534384625719",
    d: 54000000,
  },
  {
    p: "006000700053640000090000050020000907010400008000189000009530002080000060000001005",
    s: "146295783853647291792813456428356917915472638367189524679538142581724369234961875",
    d: 54000000,
  },
  {
    p: "100000782000000900702000035009024000003050020500000308000892000000005000907003001",
    s: "146539782358271964792486135869324517473158629521967348615892473234715896987643251",
    d: 54000000,
  },
  {
    p: "140000000050400000006009070600030000000000400070200010000500201020900008510703000",
    s: "147682395953417682286359174691834527832175469475296813769548231324961758518723946",
    d: 54000000,
  },
  {
    p: "000900008000004103050080000490063070200050001000100430070000000004070000516000090",
    s: "147935628689724153352681749491263875238457961765198432973516284824379516516842397",
    d: 54000000,
  },
  {
    p: "109000700000000800000069301002006007600000050080071900357000000001004000000025000",
    s: "149283765536417892728569341912856437673942158485371926357698214261734589894125673",
    d: 54000000,
  },
  {
    p: "000300200200014000007500000070030000010000752000600090000105900500008006490000500",
    s: "149376285258914637367582419975231864613849752824657391786125943532498176491763528",
    d: 54000000,
  },
  {
    p: "000400070000002000036017000500000900064000008003596040070300400010060003000000050",
    s: "152438679897652314436917285521843967964271538783596142679385421215764893348129756",
    d: 54000000,
  },
  {
    p: "100000006008020900000500030000046027000000000009000600090004300705060004810003000",
    s: "152439876348627951967518432583946127671382549429175683296754318735861294814293765",
    d: 54000000,
  },
  {
    p: "000000070000135000038020001000000500400700806005090002007001000324000000500000630",
    s: "152968374749135268638427951276814593493752816815693742967381425324576189581249637",
    d: 54000000,
  },
  {
    p: "100200000008003705030600140000030000700006000310500460000080609005402800000000000",
    s: "154279386268143795937658142586934217742816953319527468421385679675492831893761524",
    d: 54000000,
  },
  {
    p: "004000003083000025000040700000302000000000017070890000010038009020600000030900004",
    s: "154287693783169425269543781841372956392456817576891342415738269927614538638925174",
    d: 54000000,
  },
  {
    p: "000830600009000280000007500007980150000005000800020900028000000001706009006010000",
    s: "154832697739561284682497531467983152293175468815624973528349716341756829976218345",
    d: 54000000,
  },
  {
    p: "050008000000024005030050940900800200080700003003000190409010000000000000020400001",
    s: "154978326697324815832156947965831274281749653743562198479613582516287439328495761",
    d: 54000000,
  },
  {
    p: "100002003600700090070010200007000039092000050000000840005490000000260000800500000",
    s: "154982763628753491973614285487125639392846157516379842265491378739268514841537926",
    d: 54000000,
  },
  {
    p: "150000030007020000000050010000805094301009700000010000038060000000200089000000400",
    s: "154987632697123548823456917276835194381649725549712863938564271465271389712398456",
    d: 54000000,
  },
  {
    p: "000009300002010590790000100005600000040007020300104000600900000004500070073040000",
    s: "156289347432716598798435162215698734849357621367124859621973485984561273573842916",
    d: 54000000,
  },
  {
    p: "100000090020000000908003500060007201000502400000090050030005020002400060080070000",
    s: "156724398324859176978613542569347281817562439243198657631985724792431865485276913",
    d: 54000000,
  },
  {
    p: "050000000004820510308500000002007063000000002400600070200085000003000041000001000",
    s: "156794328974823516328516794892157463637948152415632879261485937583279641749361285",
    d: 54000000,
  },
  {
    p: "057000020604801050000500600420100000070300002800000109000000400000008000902006035",
    s: "157694328634821957298573614429187563571369842863245179715932486346758291982416735",
    d: 54000000,
  },
  {
    p: "000060300060270008000004900908050040300400000005809000800000096000001000000002071",
    s: "157968324469273158283514967928156743316427589745839612871345296692781435534692871",
    d: 54000000,
  },
  {
    p: "100600403000030090000201000704000000001700000680142730000507800040000005000028000",
    s: "158679423267834591493251687724963158931785264685142739316597842842316975579428316",
    d: 54000000,
  },
  {
    p: "000073400900010002000900000003060070204100000095000200406000931000000000000200007",
    s: "162573498938614752547928163813462579274159386695837214426785931789341625351296847",
    d: 54000000,
  },
  {
    p: "003009040500010809079300000080900300000053000000200010601000502000000000000080061",
    s: "163829745524617839879345126482961357716453298935278614691734582258196473347582961",
    d: 54000000,
  },
  {
    p: "000008025070500000000000070600000000080096502000040089400003800706009003010002006",
    s: "164978325278531964935264178649825731387196542521347689492613857756489213813752496",
    d: 54000000,
  },
  {
    p: "100000020703000000800005400005600900900100002000430605012500000000000000000000390",
    s: "164983527753246189829715436475628913936157842281439675312594768698371254547862391",
    d: 54000000,
  },
  {
    p: "060074000000000008829000170000700010000100630001003900530020000006030400000500000",
    s: "165874329347219568829356174693742815482195637751683942538421796276938451914567283",
    d: 54000000,
  },
  {
    p: "060000304835000700000800010002600000380000076009105000000002000090008020000500400",
    s: "167259384835416792924837615752683941381924576649175238413762859596348127278591463",
    d: 54000000,
  },
  {
    p: "060290008080000005400000070000009230000000006041038000006070002010004900900800000",
    s: "167295348389417625425386179678159234593742816241638597836971452712564983954823761",
    d: 54000000,
  },
  {
    p: "007090080500408060900000050400310000300000294000050000700120000804000906002000000",
    s: "167593482523478169948261753489312675351687294276954831795126348814735926632849517",
    d: 54000000,
  },
  {
    p: "160200950000900010000000004000000000740005006600000001802004070070600002050100090",
    s: "168247953435986217297531864521463789749815326683729541812394675974658132356172498",
    d: 54000000,
  },
  {
    p: "060020007004960000070500800520003000000070004000000060400800000200005000001000380",
    s: "169328457854967123372514896526483719918276534743159268435891672287635941691742385",
    d: 54000000,
  },
  {
    p: "070000438300020060000100000600304200051000000000090000730800000000400721005000000",
    s: "172569438349728165568143972687354219951287643423691857734812596896435721215976384",
    d: 54000000,
  },
  {
    p: "070800000350000007400000000780305400000200700001004090000038009003020000010507600",
    s: "172853964358946217496172358789365421645219783231784596527638149963421875814597632",
    d: 54000000,
  },
  {
    p: "103000409059020100200000080500000807000700014000095000002180300005000000000900000",
    s: "173568429859427163264319785536241897928736514417895632792184356385672941641953278",
    d: 54000000,
  },
  {
    p: "000020000050803007809700020000070004007560100080002600300100080000006500000090040",
    s: "173629458254813967869754321526971834437568192981432675395147286742386519618295743",
    d: 54000000,
  },
  {
    p: "100000000000070061080004030000060000002501480500490300800050070090006000450900000",
    s: "173689542249375861685214739734862195962531487518497326826153974391746258457928613",
    d: 54000000,
  },
  {
    p: "000000260000005040400000070010903000090200100080004003051000000002076000009100004",
    s: "173849265968725341425631978517963482394287156286514793651492837842376519739158624",
    d: 54000000,
  },
  {
    p: "100000003006400810003000700800004000000501300900000040000009060040050200002060050",
    s: "174825693296473815583916724825634971467591382931782546358249167649157238712368459",
    d: 54000000,
  },
  {
    p: "170000000006002058000005003690000000000080005004003070000070100800509600000210000",
    s: "175834269346192758982765413698457321237681945514923876459376182821549637763218594",
    d: 54000000,
  },
  {
    p: "076500000800000500000910300000050004062000000980020700000480010000000003307000420",
    s: "176534892893762541425918376731859264562347189984126735259483617648271953317695428",
    d: 54000000,
  },
  {
    p: "070300200020000580000080470049060000601502000000090006000000008000679000002008005",
    s: "178354269426917583593286471349761852681542937257893146734125698815679324962438715",
    d: 54000000,
  },
  {
    p: "009060003000000000502000008080009560000008019300206000000000006000040000400310070",
    s: "179864253846523197532791648784139562625478319391256784217985436953647821468312975",
    d: 54000000,
  },
  {
    p: "180000060000000800005004007300020010000509200000700439093000100600000003420000000",
    s: "182357964734962851965814327379426518841539276256781439593678142618245793427193685",
    d: 54000000,
  },
  {
    p: "000709030000600000400500097008100902000000000000025060070006004810000070000010650",
    s: "182749536597632481463581297658173942239468715741925863375896124816254379924317658",
    d: 54000000,
  },
  {
    p: "003400200000071030090005060976020004000000080400100000700049600800000000040000300",
    s: "183496275564271839297385461976823154321954786458167923732549618819632547645718392",
    d: 54000000,
  },
  {
    p: "005030060900004001007008300000020006070519000009000580600000124000001000000400000",
    s: "185732469932654871467198352543827916876519243219346587658973124794281635321465798",
    d: 54000000,
  },
  {
    p: "100200007000000000034005006800100702000000800070300405000070040200490000008026000",
    s: "186234597529617384734985126853149762461752839972368415695871243217493658348526971",
    d: 54000000,
  },
  {
    p: "180000700502000080000010040060000400900000001003809006000400005200930000000060200",
    s: "186243759542796183379518642765321498928654371413879526637482915251937864894165237",
    d: 54000000,
  },
  {
    p: "080000004000700090700001025005000300400002000001000069000804000020600000000053002",
    s: "186295734542736891739481625265179348498362517371548269953824176824617953617953482",
    d: 54000000,
  },
  {
    p: "100000906000760800000300400000030000008005300603090050810000090540800700006000500",
    s: "187254936234769815965381472751638249498125367623497158812573694549816723376942581",
    d: 54000000,
  },
  {
    p: "100000050060500000200010800041002000000004097090000000603001000908000020002038100",
    s: "189327654764589231235416879341792586826154397597863412653271948918645723472938165",
    d: 54000000,
  },
  {
    p: "100000605000007008400900002020005030060000920804010000000204007002000000000570000",
    s: "189423675236157498457986312721695834365748921894312756918234567572869143643571289",
    d: 54000000,
  },
  {
    p: "100006020730000000000100005050300700608000100300060000000040809014690003002000400",
    s: "189456327735928641426137985251389764698574132347261598563742819814695273972813456",
    d: 54000000,
  },
  {
    p: "090600700050000009460010300800300000020400000000901050004070000206040003000000210",
    s: "192638745358724169467519328841352697529467831673981452914273586286145973735896214",
    d: 54000000,
  },
  {
    p: "090003080000000700064050000010207000000000800200901400000590007850000031006000000",
    s: "192763584583124769764859123618247395947635812235981476321598647859476231476312958",
    d: 54000000,
  },
  {
    p: "000780040078003000600000001009000025020005034001800009000500000030460000900002010",
    s: "192786543578143296643259781489637125726915834351824679214598367837461952965372418",
    d: 54000000,
  },
  {
    p: "100000802002090000006002054004006080010005000005100000007050001030000000060830700",
    s: "193547862452698317786312954374926185618475293925183476847259631239761548561834729",
    d: 54000000,
  },
  {
    p: "000002400000605009605004080000908020068000000010000094000800105030009070700000000",
    s: "193782456842635719675194382354918627968247531217356894429873165531469278786521943",
    d: 54000000,
  },
  {
    p: "000800200570000000000091000000054016300100400000000003039070001410000007000900630",
    s: "193847265578623149264591378982354716357169482641782953839476521416235897725918634",
    d: 54000000,
  },
  {
    p: "000000060800026000070400309009653800002840006000000000020500400003000000700090000",
    s: "194735268835926741276481359419653827352847196687219534921568473563174982748392615",
    d: 54000000,
  },
  {
    p: "008400003005000740000260000000003500509000010000000306000007060080040007046090100",
    s: "198475623625839741473261895864123579539786214217954386952317468381642957746598132",
    d: 54000000,
  },
  {
    p: "008000500045001060000803000000010000207000000019060020060700014800000052002000006",
    s: "198642573345971268726853149684217395237594681519368427963725814871436952452189736",
    d: 54000000,
  },
  {
    p: "000800600000030000007260084600090700140000000709006500080000013000540068900000000",
    s: "213874659864935127597261384658492731142753896739186542485627913371549268926318475",
    d: 54000000,
  },
  {
    p: "210760800000900070000002000100005430580230000302000000009007080005380000000020000",
    s: "214763895653948271978512346196875432587234619342196758429657183765381924831429567",
    d: 54000000,
  },
  {
    p: "000060807030500000400009032008000070020000004700092008050083000000000069600000000",
    s: "215364897839527146467819532198456273526738914743192658954683721381275469672941385",
    d: 54000000,
  },
  {
    p: "000004003087090600400010008051060000000000400900080000003900000620070004000100705",
    s: "216854973587293641439617528351469287768532419942781356173945862625378194894126735",
    d: 54000000,
  },
  {
    p: "000000004000071009093080000004090000007500001058700600060050003009310000000800270",
    s: "216935784485671329793284156624198537937526841158743692862457913579312468341869275",
    d: 54000000,
  },
  {
    p: "207000000000600040800000300000008002900704030740030000000000090008000007601890000",
    s: "217349568539682741864517329153968472982754136746231985425176893398425617671893254",
    d: 54000000,
  },
  {
    p: "200005684900001005060780000002000000000007008300060070050000006090530100000400000",
    s: "217395684938641725564782913172853469649127358385964271451279836796538142823416597",
    d: 54000000,
  },
  {
    p: "200000960890003000000700040605809300000000070000070000030010004000200000900300650",
    s: "217458963894623715563791842675849321189532476342176598736915284458267139921384657",
    d: 54000000,
  },
  {
    p: "007080300005000007040060200000500000008000700000913008402000089900000020000001000",
    s: "217485396365129847849367215134578962598642731726913458452736189971854623683291574",
    d: 54000000,
  },
  {
    p: "000000040090030000004020016000100000083040270000000490109000007700006000040090080",
    s: "217568349896431725354927816472189563983645271561372498129854637738216954645793182",
    d: 54000000,
  },
  {
    p: "218300000900040060000000002300700910070000005040000800000970030060400708000080001",
    s: "218356479957248163436197582385724916172869345649531827821975634563412798794683251",
    d: 54000000,
  },
  {
    p: "000000600409000008056000002020403000070002504000100030080700000060280100002306009",
    s: "218547693439621758756938412625473981173892564894165237981754326367289145542316879",
    d: 54000000,
  },
  {
    p: "008063000050000000300000008000900034000802000400030079040010300906008001005007000",
    s: "218563497659784123374291568581976234793842615462135879847619352926358741135427986",
    d: 54000000,
  },
  {
    p: "018000400049003000000028000000000391000500200001090000506070000007000002000002058",
    s: "218956473649713825375428619752684391964531287831297546526879134187345962493162758",
    d: 54000000,
  },
  {
    p: "200000050009006712000100000080003004700002000300009000803000006000000100002040379",
    s: "218974653549386712637125498981763524764852931325419867873591246496237185152648379",
    d: 54000000,
  },
  {
    p: "210300600060000904000090000000000010801607000000000203600750020050403000008000070",
    s: "219384657563172984487596132346925718821637549975841263694758321752413896138269475",
    d: 54000000,
  },
  {
    p: "009750006030009002000400050020070000003008000090000040000000637060042800008000000",
    s: "219753486534869172786421359621374598473598261895216743942185637367942815158637924",
    d: 54000000,
  },
  {
    p: "000085006000000040408000010720500003000823000600070000100000000040900260076000450",
    s: "231485976957361842468792315729546183514823697683179524192654738845937261376218459",
    d: 54000000,
  },
  {
    p: "200008500090570004000400060549000700003000020020050080000000090000013000307006000",
    s: "234168579698572314175439268549281736813697425726354981461725893952813647387946152",
    d: 54000000,
  },
  {
    p: "234000068800000004000800002008370000002000040000026709510000000000103020007600500",
    s: "234715968865932174179864352648379215792581643351426789513247896986153427427698531",
    d: 54000000,
  },
  {
    p: "000007800000000032186000000000086004600000000093701000010300500000008140009000060",
    s: "235647891947815632186293457521986374678432915493751286714369528362578149859124763",
    d: 54000000,
  },
  {
    p: "030400008500002000107600000000230000043000007710800300000000010000045009060000230",
    s: "236459178584712693197683542659237481843561927712894356975326814328145769461978235",
    d: 54000000,
  },
  {
    p: "000090008400000300007600002020100903003006007000200000078300040309080005600070000",
    s: "236594718451728396987613452824157963193846527765239184578361249319482675642975831",
    d: 54000000,
  },
  {
    p: "200000090000100034000900000000017000020000060670090500050004610010050040003000009",
    s: "237486195869175234145923876598617423321548967674392581952734618716859342483261759",
    d: 54000000,
  },
  {
    p: "208000600540200000009030000700000180000008040400609070005040300000802000000007400",
    s: "238194657547286931169735824756423189913578246482619573875941362394862715621357498",
    d: 54000000,
  },
  {
    p: "200008700804000001010000030090305000078009000100060040721080000000003006000000005",
    s: "239158764864937521517624839492375618678419352153862947721586493985243176346791285",
    d: 54000000,
  },
  {
    p: "009000000700800320001000405890000063510060009000030700002000000900070108100006000",
    s: "239654817745891326681327495897412563513768249426935781352189674964273158178546932",
    d: 54000000,
  },
  {
    p: "009006004010000020005800030080000000006901200001005400100008003020060050700100000",
    s: "239756814817349526645812739582674391476931285391285467164528973923467158758193642",
    d: 54000000,
  },
  {
    p: "040001000100000039570000600900700080080003006000060400800020700000508090090000002",
    s: "243691578168457239579382641926745183487213956351869427834926715612578394795134862",
    d: 54000000,
  },
  {
    p: "203700010080005002060300000000006704316000000000000009050000091800070000900020000",
    s: "243798516189465372765312948592186734316947825478253169657834291821679453934521687",
    d: 54000000,
  },
  {
    p: "000000007000040080008009320050020000102900605000063700000000008005600000430000501",
    s: "243816957597342186618759324356127849172984635984563712761435298825691473439278561",
    d: 54000000,
  },
  {
    p: "003000060001030007000240500000079001800000904060000000026000009008020010000300400",
    s: "243957168951638247687241593534879621812563974769412835326184759498725316175396482",
    d: 54000000,
  },
  {
    p: "005061000060000040100300002730000005004030900000070000000400607020000800509200000",
    s: "245861793367925148198347562731694285684532971952178436813459627426713859579286314",
    d: 54000000,
  },
  {
    p: "045003001803000009070020000000008025520100008000600000006000140050000800400000906",
    s: "245963781813475269679821534164798325527134698398652417736589142951246873482317956",
    d: 54000000,
  },
  {
    p: "007001300030000095001000400000908000060054000800360040075000902000020000420700008",
    s: "247591386638472195591683427754918263963254871812367549175846932386129754429735618",
    d: 54000000,
  },
  {
    p: "000005000000070402083090000020060005700204000090000080002000300600300708005000010",
    s: "247635891569871432183492576328967145751284963496513287872146359614359728935728614",
    d: 54000000,
  },
  {
    p: "007090000000002009005300640700000006000000200500800430002079300000504000009003100",
    s: "247698513316452789985317642724931856638745291591826437852179364173564928469283175",
    d: 54000000,
  },
  {
    p: "000700109076000400130460008800090000003006004900540000000000017690010500000005000",
    s: "248753169576981432139462758814397625753126894962548371485639217697214583321875946",
    d: 54000000,
  },
  {
    p: "008053670000000354000004000400009800002000030000718006830006000001000900000070000",
    s: "248953671619287354753164298476329815182645739395718426837596142561432987924871563",
    d: 54000000,
  },
  {
    p: "049300000603000500010000000050070000000006300080000102000600027002048000090001040",
    s: "249385761673124589815967234351872496927416358486593172134659827562748913798231645",
    d: 54000000,
  },
  {
    p: "040500030000300901100000508000000467060013009900800000890002000020400010006000000",
    s: "249581736685374921137269548318925467564713289972846153891652374723498615456137892",
    d: 54000000,
  },
  {
    p: "050000000000000307900042001600004008030000000010750000000490100008000560300010900",
    s: "253187496481569327976342851625934718739821645814756239562498173198273564347615982",
    d: 54000000,
  },
  {
    p: "000000000090430000140970000020097604006000000300080010460000500081000007002010000",
    s: "253861749697432158148975263825197634916354872374286915469723581581649327732518496",
    d: 54000000,
  },
  {
    p: "000010008487000050600005000000059430000300000060041000000000500002090800000600270",
    s: "253917648487263159619485327721859436948326715365741982836172594172594863594638271",
    d: 54000000,
  },
  {
    p: "004000070900320004000009005002010000100030060500008700600000030007000080000091400",
    s: "254186973976325814381479625762514398148937562539268741695842137417653289823791456",
    d: 54000000,
  },
  {
    p: "000000906000600050300000708071200000025000093800000000000902300007050020400801000",
    s: "254718936789634251316529748971263485625487193843195672568942317197356824432871569",
    d: 54000000,
  },
  {
    p: "000030001000400900019000370008005000000000760620070000900000000003080246002307000",
    s: "254739681367418925819256374738695412495123768621874593986542137573981246142367859",
    d: 54000000,
  },
  {
    p: "050917000000000000008000090002003905040005003060080001000060200600400100010050300",
    s: "254917638796834512138526794872143965941675823365289471587361249623498157419752386",
    d: 54000000,
  },
  {
    p: "200000040000050000904007503370000902000790000590000010000100020000002800080970006",
    s: "257369148863451279914827563376514982421798635598236714649185327735642891182973456",
    d: 54000000,
  },
  {
    p: "050006100030200000000900007080000200005001080001000640502039000009060400000120700",
    s: "257386194934217568168954327486593271725641983391872645572439816819765432643128759",
    d: 54000000,
  },
  {
    p: "200069080000032000430005000000006900000040600100000002000007319009001050800050000",
    s: "257469183981732564436815297328176945795248631164593872542687319679321458813954726",
    d: 54000000,
  },
  {
    p: "050900000800402060000050300006800409008006070004500600000030000002000013400009000",
    s: "257963841813472965649158327376821459598346172124597638781635294962784513435219786",
    d: 54000000,
  },
  {
    p: "000300160000008030000005000100000000039060000700094200060007402000000900890000010",
    s: "258379164674218539913645728142583697539762841786194253361957482425831976897426315",
    d: 54000000,
  },
  {
    p: "000000410000006070006140000031000009004005000000390000005400130003600720012007000",
    s: "258973416149256873376148952531764289924815367687392541765429138493681725812537694",
    d: 54000000,
  },
  {
    p: "000040003000007090070020600001490070085003009000000400900000000600018020500700008",
    s: "259146783146387592873925641361492875485673219792851436918264357637518924524739168",
    d: 54000000,
  },
  {
    p: "200003009700900000009000270604000000000001000530000610045000000000017900000680050",
    s: "261873549753942861489156273614725398978361425532498617145239786826517934397684152",
    d: 54000000,
  },
  {
    p: "000070009500100640481600000000090000000701000000000938900030070000500000104000005",
    s: "263475189579183642481629753642398517398751264715246938956832471827514396134967825",
    d: 54000000,
  },
  {
    p: "000000000005196000400000060000041300306008000050020007004902010670005080000000900",
    s: "263584791785196432491237865927641358346758129158329647834972516679415283512863974",
    d: 54000000,
  },
  {
    p: "004000900000000300305490080020001006003000070006030500000800001070040050002905000",
    s: "264378915798156324315492687927581436453629178186734592539867241671243859842915763",
    d: 54000000,
  },
  {
    p: "207000000000000800000075009800000003054021000900560000040107080000230150005000090",
    s: "267983415593412876481675239816794523754321968932568741349157682678239154125846397",
    d: 54000000,
  },
  {
    p: "068001000000030040401500200050000839970000000000640070000000014000050320000060005",
    s: "268491753795832146431576298654217839972385461813649572589723614146958327327164985",
    d: 54000000,
  },
  {
    p: "009003000000000058400709000007006500090000600010408000945007001080000020006000800",
    s: "269583147371642958458719236837296514594371682612458793945827361783165429126934875",
    d: 54000000,
  },
  {
    p: "000000100060080070580060000050908460300500001000100000040000000007000510900000803",
    s: "273495186164283975589761234751938462328546791496172358845319627637824519912657843",
    d: 54000000,
  },
  {
    p: "070000006000000050050006304130000000002900067009002400900700000500080002010600008",
    s: "273541986694378251851296374135467829482935167769812435928754613546183792317629548",
    d: 54000000,
  },
  {
    p: "003008500000000002149000070001002007090300000005067000600005010000000040410080000",
    s: "273918564586734192149526873361892457794351286825467931638245719952173648417689325",
    d: 54000000,
  },
  {
    p: "000300690040000001100090700000001008410700360590000007360050809000803000000000500",
    s: "275318694943675281186294753637521948412789365598436127364152879759863412821947536",
    d: 54000000,
  },
  {
    p: "000060000030059060090003400008090004000802010007000000700500000000040008009008350",
    s: "275461893834759162691283475128695734346872519957314286782536941513947628469128357",
    d: 54000000,
  },
  {
    p: "000000000400200708006097020010608004000120000050040007300000059840000301500000000",
    s: "275486193493251768186397425912678534734125986658943217327814659849562371561739842",
    d: 54000000,
  },
  {
    p: "200600004000000070900000502000504800082009000100000000057100090003000000000070023",
    s: "275691384364258971918743562736524819582319746149867235657132498423986157891475623",
    d: 54000000,
  },
  {
    p: "200008400000003061000700000092000607010007020008000030360500100000090070000000008",
    s: "276158493589423761134769582492835617613947825758216934367582149845391276921674358",
    d: 54000000,
  },
  {
    p: "000083000040002005000900000007100009510000060000000470080400000001806032000390600",
    s: "279583146348612795165947823827164359514739268936258471683425917491876532752391684",
    d: 54000000,
  },
  {
    p: "000000001100000000000004529060400080002060300054030600090000050080305000001007004",
    s: "279853461145926873638714529963472185812569347754138692396241758487395216521687934",
    d: 54000000,
  },
  {
    p: "001000063003100800000600009045080000000000200032900780600704000000002000000000952",
    s: "281479563963125847457638129745283691896517234132946785629754318518392476374861952",
    d: 54000000,
  },
  {
    p: "200000500730004020400090010000002800000060000006000709502086040000000000090507000",
    s: "281673594739154628465298317954732861317869452826415739572986143648321975193547286",
    d: 54000000,
  },
  {
    p: "000040000507980004400000083002600900000000040030090205860050070000000100004710000",
    s: "283546791517983624496271583742635918659128347138497265861352479975864132324719856",
    d: 54000000,
  },
  {
    p: "000005000004001800010080306800600900000000030030040000740050028060020700300010000",
    s: "283965471694731852517284396852673914476198235931542687749356128165829743328417569",
    d: 54000000,
  },
  {
    p: "204003060070600000600002004000001708002000640700000031300060010000000050000450800",
    s: "284793165975614382631582974563941728812375649749826531358269417497138256126457893",
    d: 54000000,
  },
  {
    p: "080900100000001000049002380400000090000300700800005002000600005502000006070004010",
    s: "285973164736481529149562387453827691921346758867195432394618275512739846678254913",
    d: 54000000,
  },
  {
    p: "080300004001480000090000012000000290000000005700060008030001020005806009000900300",
    s: "287319654561482937493657812816574293342198765759263148938741526125836479674925381",
    d: 54000000,
  },
  {
    p: "000500060004010000130900800008003600010270030000400500000700020609000008000002000",
    s: "287534169964817253135926847498153672516278934372469581853791426629345718741682395",
    d: 54000000,
  },
  {
    p: "080300400000096000003800000007500000100000600005600980050900067090030000800001090",
    s: "289357416574196832613842759967518324138429675425673981351984267796235148842761593",
    d: 54000000,
  },
  {
    p: "009500100050007002040000000000081070000405000000000053406000030020890000030000090",
    s: "289536147651947382347218569562381974973465821814729653496152738725893416138674295",
    d: 54000000,
  },
  {
    p: "209500100003000540500000000000900000800630001000701830008300000060002700001070092",
    s: "289543167613297548547816329136985274872634951495721836728369415964152783351478692",
    d: 54000000,
  },
  {
    p: "290000008005010000040080060000060205100003600004000790012000000000000007000408002",
    s: "291645378865317429743982561389764215157293684624851793412579836538126947976438152",
    d: 54000000,
  },
  {
    p: "001005000000400000630002071000020000000017659000009100005000004000060820708000060",
    s: "291675348857431296634982571913526487482317659576849132365298714149763825728154963",
    d: 54000000,
  },
  {
    p: "200004057534000000000300900605009104007000000100063020800010000000007000000002600",
    s: "291684357534791862768325941685279134327148596149563728852916473916437285473852619",
    d: 54000000,
  },
  {
    p: "000100400850903000000050070000370006000000040070602100006700820000830000300001000",
    s: "293167458857943261461258379512374986638519742974682135146795823729836514385421697",
    d: 54000000,
  },
  {
    p: "200005083700403000000000500000000600009012400000600008050020000041807050600000000",
    s: "294165783785493162136278594513784629869312475472659318357926841941837256628541937",
    d: 54000000,
  },
  {
    p: "000750030010000002060280907050010003000003060006000000400300020000070800009500010",
    s: "294756138817934652563281947952617483178423569346895271481369725635172894729548316",
    d: 54000000,
  },
  {
    p: "090010060700000000000000304800020010005000200000309040001000059050170000302060100",
    s: "294813765783546921516792384869427513435681297127359846671238459958174632342965178",
    d: 54000000,
  },
  {
    p: "000040000060005100074003000917000800000560003300000000000000000500097400020000395",
    s: "295148637863975124174623589917234856482561973356789241649352718531897462728416395",
    d: 54000000,
  },
  {
    p: "005001000107000003060209000300400000000000502000000068080000409030100020600780000",
    s: "295371684147568293863249751358426917976813542412957368581632479734195826629784135",
    d: 54000000,
  },
  {
    p: "000000806000005090000000000010049300009823007700050000000007008108200760040030000",
    s: "295371846671485293384962571816749352459823617723156984962517438138294765547638129",
    d: 54000000,
  },
  {
    p: "090000008000006050005000031070003100000060500004900027403080790560030000020040000",
    s: "296351478341876952785294631879523146132467589654918327413682795568739214927145863",
    d: 54000000,
  },
  {
    p: "000057080000002300003000070000620004900000500600091000050900000040003700002000009",
    s: "296357481478162395513489672735628914921734568684591237157946823849213756362875149",
    d: 54000000,
  },
  {
    p: "090105080400009700100000200010500004900306000076004000000700032000000007023000100",
    s: "297145683438269715165873249312587964984326571576914328649751832851632497723498156",
    d: 54000000,
  },
  {
    p: "007000065005028001080005000912400000000030000000000006800600709500290000020000030",
    s: "297341865365728941184965273912486357756139482438572196841653729573294618629817534",
    d: 54000000,
  },
  {
    p: "200400080080910003000600070000130004003040020008065700070000000109000000500000002",
    s: "297453186486917253351682479725138964613749528948265731872394615139526847564871392",
    d: 54000000,
  },
  {
    p: "000000608000000950003200000009740020001006000020800070406900500805000000000430000",
    s: "297514638148673952563298741689741325751326489324859176476982513835167294912435867",
    d: 54000000,
  },
  {
    p: "000017050056020001301406000000003809563000000000200000830600200000900000004031000",
    s: "298317456456829371371456982142573869563198724987264135839645217715982643624731598",
    d: 54000000,
  },
  {
    p: "008610000000500109000003000003000000900002005500801060002740030609000000100000802",
    s: "298614753346587129715293486463975218981462375527831964852749631639128547174356892",
    d: 54000000,
  },
  {
    p: "000640310000000000701003002046010000802000703000000060500290000000004000000700084",
    s: "298645317463172958751983642946317825812456793375829461534298176187564239629731584",
    d: 54000000,
  },
  {
    p: "000001500713046000004000000000009000407000600029000301000965000836000002000080070",
    s: "298731564713546829654298713361859247487123695529674381172965438836417952945382176",
    d: 54000000,
  },
  {
    p: "000070080000100000000032507001053000500040000093000020030000072028700001060008000",
    s: "312574689759186243684932517241853796576249138893617425935461872428795361167328954",
    d: 54000000,
  },
  {
    p: "310000054095000000000000800020107300070009000106005000000000108001000007750460030",
    s: "312896754895714623647253891529147386473689215186325479934572168261938547758461932",
    d: 54000000,
  },
  {
    p: "012080000000000090900000087400500000087000403000000051790040000050708010000063000",
    s: "312987546874356192965421387431572869587619423629834751796145238253798614148263975",
    d: 54000000,
  },
  {
    p: "004050209000000170070900000030200400080000000605004003743100000009300002000090050",
    s: "314758269592643178876912534937261485481539627625874913743125896159386742268497351",
    d: 54000000,
  },
  {
    p: "310060090000000030070002040000009607100450900200008000560000004000000000900510200",
    s: "314765892852941736679832541435129687187456923296378415568293174721684359943517268",
    d: 54000000,
  },
  {
    p: "010020005008000030007300001409500600630400000000079000000050009900000050006700002",
    s: "314926875598147236267385491479532618635418927821679543742853169983261754156794382",
    d: 54000000,
  },
  {
    p: "010080700006049005984000000002010300851007000690000000060800170000000600000300020",
    s: "315286749726149835984573261472915386851637492693428517269854173138792654547361928",
    d: 54000000,
  },
  {
    p: "000600000000050006000024301000009070060040020500010008070001000054800790230000000",
    s: "315698247742153986689724351421389675863547129597216438978431562154862793236975814",
    d: 54000000,
  },
  {
    p: "310840007200050000500006000025007090009080070700000100001090000000004020040060800",
    s: "316842957278951436594376281425617398169483572783529164631298745857134629942765813",
    d: 54000000,
  },
  {
    p: "000400000000780204020000003086075000730060000500000080005004001000190300070006800",
    s: "317452968659783214824619573486975132731268495592341687965834721248197356173526849",
    d: 54000000,
  },
  {
    p: "010050000000800600004020007053060004400000002000905031239400000000000000000580010",
    s: "317654298925871643864329157153268974498137562672945831239416785581793426746582319",
    d: 54000000,
  },
  {
    p: "000040060600007300980300000000201058100500020000000003000000805070000900023980007",
    s: "317845269652197384984326571739261458148539726265478193496712835871653942523984617",
    d: 54000000,
  },
  {
    p: "008460009004000000700013080907826500000000000000705020000090100036000002080000700",
    s: "318467259624589317795213486947826531253941678861735924472398165536174892189652743",
    d: 54000000,
  },
  {
    p: "008006000900701060020008000700039000030004000000000100400000091250000400000070002",
    s: "318596724945721368627348915784139256132654879569287143473862591256913487891475632",
    d: 54000000,
  },
  {
    p: "300002074000000500900000002400807010000009600075000000004765000000910803000000000",
    s: "318652974742391568956478132469827315183549627275136489834765291627914853591283746",
    d: 54000000,
  },
  {
    p: "309040070405007320000000000540600090000000250200091700000030060000004900732060000",
    s: "319246875465817329827359614543672198971483256286591743194738562658124937732965481",
    d: 54000000,
  },
  {
    p: "010008500600700001750004890500002000000000900900001002000800360000906000030000040",
    s: "319268574648759231752314896587492613124683957963571482291847365475936128836125749",
    d: 54000000,
  },
  {
    p: "000076000200109000007800010004000005060500001001000000090607000008001903030005002",
    s: "319276584285149376647853219924718635763594821851362497492637158578421963136985742",
    d: 54000000,
  },
  {
    p: "300000050007300061602070000060510000900040230000000100000800020078020400000000000",
    s: "319468752847352961652971384264513879981647235735289146196834527578126493423795618",
    d: 54000000,
  },
  {
    p: "000040065700026000900037000450000083010003000800060000000410507000000028000000030",
    s: "321948765748526319965137842456791283219853476837264951683412597194375628572689134",
    d: 54000000,
  },
  {
    p: "325008000800000063000700005600201000200000430009004000010080700903000000002690000",
    s: "325168947871549263496723185647231859258976431139854672514382796963417528782695314",
    d: 54000000,
  },
  {
    p: "000000070004320000000400500050009000000807200410600009702000300009006080000000006",
    s: "325968174174325968986471523258139647693847215417652839762584391539716482841293756",
    d: 54000000,
  },
  {
    p: "020009000000030000546000000000004080100500300003080200000071000000008096600000401",
    s: "327869154819435762546127938275314689168592347493786215954671823731248596682953471",
    d: 54000000,
  },
  {
    p: "020070600000290000000008140807020001500100008009000300700900004432000000000000080",
    s: "328471695154296837976538142867329451543167928219854376785913264432685719691742583",
    d: 54000000,
  },
  {
    p: "008090100001000908500040000740036000006204000800009700005300010000000063000007000",
    s: "328695174461723958597148632749836521156274389832519746985362417274951863613487295",
    d: 54000000,
  },
  {
    p: "000000008000026910017000000030160057000005320500009000000000080800300000206004000",
    s: "329541678485726913617983542932168457168475329574239861753692184841357296296814735",
    d: 54000000,
  },
  {
    p: "000007100051000600000030040000900000007061003820000000409010000200800051070002000",
    s: "342687195751294638968135742613928574597461283824753916489516327236879451175342869",
    d: 54000000,
  },
  {
    p: "040900000000000340007300000070009000006030080001800005250007401000000006100000520",
    s: "342916758619578342587324619875149263926735184431862975253687491794251836168493527",
    d: 54000000,
  },
  {
    p: "000610020001209000020050100000007050006004908030100060400000010000000400500900800",
    s: "345618729861279543927453186294867351156324978738195264489732615673581492512946837",
    d: 54000000,
  },
  {
    p: "005700090001060704907000001038001000000800203700000000000043059100080002000900040",
    s: "345712698821569734967438521438251967659874213712396485276143859194685372583927146",
    d: 54000000,
  },
  {
    p: "000000000500001008000700090000600940090308060203000000020010030000040050005002104",
    s: "346289517579461328182735496851627943794358261263194875428516739917843652635972184",
    d: 54000000,
  },
  {
    p: "000901000000000700600000024408000002200009030700300010800060100004500070000070840",
    s: "347921685582436791619857324438715962251689437796342518873264159164598273925173846",
    d: 54000000,
  },
  {
    p: "300200050092000100000000904004005000050879200000000000010000003800000000500304610",
    s: "348291756792546138165738924284615379653879241971423865417962583836157492529384617",
    d: 54000000,
  },
  {
    p: "009700000060000940001000000180007000000102060000840300502001700000080021000009006",
    s: "349726185765318942821954673183697254954132867276845319532461798697583421418279536",
    d: 54000000,
  },
  {
    p: "000080000007900000900003120700100045002060709005070030000000060040000000136000904",
    s: "351286497827941356964753128783192645412365789695874231278419563549637812136528974",
    d: 54000000,
  },
  {
    p: "000008200000910000900000430000049003005037000070200000000504106800000090040100000",
    s: "351468279724913865968725431182649753495837612673251948237594186816372594549186327",
    d: 54000000,
  },
  {
    p: "000000809040005600020100005900000007063000000000086030030009008200700001405200000",
    s: "351647829749825613826193475984352167563471982172986534637519248298764351415238796",
    d: 54000000,
  },
  {
    p: "000000040800300000049600800070520690010870000000000000000200050007006380034001000",
    s: "351798246862345917749612835478523691615879423293164578986237154127456389534981762",
    d: 54000000,
  },
  {
    p: "351060000080009000900050302600000803010030000000500004007001020000000078000200600",
    s: "351862947782349156964157382675924813418736295293518764537681429126493578849275631",
    d: 54000000,
  },
  {
    p: "300200900000070501000000600100050002007009003000003040983000000200000098005030000",
    s: "354216987698374521721895634139457862847629153562183749983762415276541398415938276",
    d: 54000000,
  },
  {
    p: "054800170700000050000006002090084000002000403078000000005903000000000810000100200",
    s: "354892176726341958981576342193684527562719483478235691815923764239467815647158239",
    d: 54000000,
  },
  {
    p: "300040000280500900000012008600090100000000036007400000760900300000003800000020071",
    s: "356849712281567943479312658643295187592178436817436295765981324124753869938624571",
    d: 54000000,
  },
  {
    p: "300000100001080600048005009090034050680050000005090000000000090800001200000009040",
    s: "356972184921483675748615329197234856684157932235896417463728591879541263512369748",
    d: 54000000,
  },
  {
    p: "307006000000005070800002000900300001106000500020070009060850300000000987000040000",
    s: "357486192612935478894712635985364721176298543423571869269857314541623987738149256",
    d: 54000000,
  },
  {
    p: "050000901000930800004060000570006400001007600000520009000070003080000000195000000",
    s: "358742961267931854914865372579316428821497635436528719642179583783254196195683247",
    d: 54000000,
  },
  {
    p: "308000000000740300000000052000070001091080705000009020007000013010096570400000900",
    s: "358921647126745389749863152683572491291684735574139826967458213812396574435217968",
    d: 54000000,
  },
  {
    p: "000000462100200800000045000200700000037600009000480020002000006040090000506000030",
    s: "359178462174263895628945371281739654437652189965481723892317546743596218516824937",
    d: 54000000,
  },
  {
    p: "000000000187300500000105009620004300500800100090000064014000900000200000000000687",
    s: "359476218187392546462185739628714395543869172791523864814657923976238451235941687",
    d: 54000000,
  },
  {
    p: "009000000010000007802009060080032000060800503005097000020003000000470005000060001",
    s: "359746182416328957872159364184532679967814523235697418521983746698471235743265891",
    d: 54000000,
  },
  {
    p: "000000004000002760006130800090000000083005070510600038000009000002403000900050100",
    s: "359768214841592763726134895697381452283945671514627938475819326162473589938256147",
    d: 54000000,
  },
  {
    p: "300200000000000500800609041600001430000782050000000000078090000010000002936000700",
    s: "361245879429817563857639241682951437143782956795463128278596314514378692936124785",
    d: 54000000,
  },
  {
    p: "000059000570000203200000609920000105000040000106000820030500080000004000000010000",
    s: "361259478579468213284371659923687145758142396146935827437526981615894732892713564",
    d: 54000000,
  },
  {
    p: "001008400000403000270090000720000080000000740800170052095300000000000903000800000",
    s: "361728495958413627274695831726534189513982746849176352695347218487251963132869574",
    d: 54000000,
  },
  {
    p: "060005000009400000400029000008200001090010080040030590000706128600000007000000065",
    s: "361875249829461753475329816538294671296517384147638592953746128684152937712983465",
    d: 54000000,
  },
  {
    p: "060800050090040003000003600043590007075000004900200000500000000800700930030000082",
    s: "362817459198645273457923618643598127275136894981274365526389741814752936739461582",
    d: 54000000,
  },
  {
    p: "360000700009050010000760000040005300000609000008010009600400580800000000001000620",
    s: "365192748479853216182764935946285371713649852258317469697421583824536197531978624",
    d: 54000000,
  },
  {
    p: "000004000009800003002000090501002080080060000000070420150000008030040001000000060",
    s: "365914872479826513812753694541392786287465139693178425156237948738649251924581367",
    d: 54000000,
  },
  {
    p: "005000000200006000080000430000090005010000070620400900800207160000600050000000009",
    s: "365984712241736598987521436478193625519862374623475981894257163132649857756318249",
    d: 54000000,
  },
  {
    p: "000000490902500000500008000000070006103002080020005301009760003080004000700000000",
    s: "368217495942536718517498632895173246173642589624985371459761823281354967736829154",
    d: 54000000,
  },
  {
    p: "008020009000090200000600800700000030000200900950304010030010080590000000040003006",
    s: "368421579415798263279635841724159638183267954956384712637912485591846327842573196",
    d: 54000000,
  },
  {
    p: "009082000050090000004000013000030107006400000400000009020050600130000000000200800",
    s: "369182475751394286284567913892635147576419328413728569927851634138946752645273891",
    d: 54000000,
  },
  {
    p: "009500001070000002200000309050608000000300700006190500000010000008000000105906020",
    s: "369524871571839642284761359953678214812345796746192538627413985498257163135986427",
    d: 54000000,
  },
  {
    p: "300080000702100000005000800000200061107806000090400000000005204030000090521004000",
    s: "369582417782143659415967823843279561157836942296451378978615234634728195521394786",
    d: 54000000,
  },
  {
    p: "009704001200000040500000000000063007006200000800010530080050010600000000000009025",
    s: "369724851218536749574198362451963287736285194892417536987652413625341978143879625",
    d: 54000000,
  },
  {
    p: "000015042000006000020039050000024590000900000208000000070600020800500001046000000",
    s: "369815742485276139127439856613724598754968213298351674971683425832547961546192387",
    d: 54000000,
  },
  {
    p: "000000940082000030046030580003100490004800005720090010000609000000050700000080000",
    s: "371528946582946137946731582653172498194863275728495613237619854869354721415287369",
    d: 54000000,
  },
  {
    p: "072610000050004000000700006000053000001000092000060078006900000020000807008000900",
    s: "372618459659324781184795236897253614561847392243169578736982145925431867418576923",
    d: 54000000,
  },
  {
    p: "302000000000070400405000076010000000000009000500300049000864003006000000000091052",
    s: "372645981169278435485913276913427568648159327527386149251864793796532814834791652",
    d: 54000000,
  },
  {
    p: "074008100690400000000002000087950030000806050040300080000000015405060000001000000",
    s: "374598162692431578158672943287954631913826754546317289769283415435169827821745396",
    d: 54000000,
  },
  {
    p: "070180049000020010000000060640005000100002096007000000403000800510700000000090000",
    s: "375186249864927513921453768649815372158372496237649185493261857516738924782594631",
    d: 54000000,
  },
  {
    p: "000200000060000000000090030050000004007030090000170000003049100000600000790800250",
    s: "375268419961354728842791635156982374287436591439175862623549187518627943794813256",
    d: 54000000,
  },
  {
    p: "005020009000050307906030000031000005007001830000600001000008900800000200009700000",
    s: "375824619184956327926137548431289765697541832258673491762318954813495276549762183",
    d: 54000000,
  },
  {
    p: "000904000009060070104030000730500040001002030000046000000070005950000700000001060",
    s: "375984621289165473164237598736518942541792836892346157613479285958623714427851369",
    d: 54000000,
  },
  {
    p: "370400000000090000160030000900000200007800000000002801600940007000107400005000060",
    s: "378426915524791638169538724981654273237819546456372891612945387893167452745283169",
    d: 54000000,
  },
  {
    p: "079000610008000003600070000046500000000600008200093005000010300000038547000005800",
    s: "379854612418926753625371984146587239593642178287193465854719326961238547732465891",
    d: 54000000,
  },
  {
    p: "380500290009028000050300000005002410000034000000700000700906104000000800004070000",
    s: "381547296479628531652391748935862417267134985148759623723986154596413872814275369",
    d: 54000000,
  },
  {
    p: "002000700100004000000003291009308002050040100000000050000000508600470000000021060",
    s: "382519746197264835564783291419358672253647189876192354741936528628475913935821467",
    d: 54000000,
  },
  {
    p: "380000620000000005070040000000276090001000038000000000006800570090067800007002300",
    s: "384195627619723485275648913538276194761954238942381756426839571193567842857412369",
    d: 54000000,
  },
  {
    p: "300060000002000090071080200020000571003000000090014600200570000000000007750090300",
    s: "385269714642157893971483265428936571163725489597814632239578146816342957754691328",
    d: 54000000,
  },
  {
    p: "300700900000039000000000010050080090600100007004600020090000051000025400730000200",
    s: "386712945517439862249568713153287694628194537974653128492876351861325479735941286",
    d: 54000000,
  },
  {
    p: "000710040500004800002300600003000004900503000000006020020009000400000000830000570",
    s: "386715942591264837742398615263981754974523168158476329627159483415837296839642571",
    d: 54000000,
  },
  {
    p: "300700092000060000241090000020800000900000040003010070090034000007000100000100008",
    s: "386741592579362481241598367724853619915627843863419275198234756637985124452176938",
    d: 54000000,
  },
  {
    p: "000900000001500700600078030170090540800003007005800000000060050000000402900400600",
    s: "387914265421536789659278134173692548864153927295847316742369851536781492918425673",
    d: 54000000,
  },
  {
    p: "080001000000809000004060200706002030950007000008000700007090300000000640600340007",
    s: "389421576562879413174563289746182935951637824238954761417296358893715642625348197",
    d: 54000000,
  },
  {
    p: "309002060000500300500080020000040891000720000094000000400007030030000008018000700",
    s: "389472165142596387567381429273645891851729643694138572425817936736954218918263754",
    d: 54000000,
  },
  {
    p: "080706020000000000400891000000000040000002900807030650003007501010060000006000400",
    s: "389746125671523894425891376162958743534672918897134652943287561718465239256319487",
    d: 54000000,
  },
  {
    p: "091008740800070000007000002900100080003000000000050003000920410500007000080000030",
    s: "391268745862574391457391862975143286623789154148652973736925418514837629289416537",
    d: 54000000,
  },
  {
    p: "000000200750000000000001354000400620000600507007090000600109000015000003208030000",
    s: "391548276754362189826971354539487621482613597167295438673159842915824763248736915",
    d: 54000000,
  },
  {
    p: "000000704000093800000002000800001000004000200700500406020704030070000000000800001",
    s: "391658724247193865685472193869241357514367289732589416926714538178935642453826971",
    d: 54000000,
  },
  {
    p: "390600001000000070000801050002000000000020530600000040009000000005067083070080009",
    s: "394675821581249376267831954712354698948126537653798142839412765125967483476583219",
    d: 54000000,
  },
  {
    p: "000000000000362000600090140060003000030010092027000050000700800000001009900800060",
    s: "395174286841362975672598143469253718538417692127986354256749831784631529913825467",
    d: 54000000,
  },
  {
    p: "095010007001004060000070000020800700004000980009100502000000020000089005000403600",
    s: "395612847781534269642978351523896714174325986869147532958761423436289175217453698",
    d: 54000000,
  },
  {
    p: "006700520050000080007060000900002000000637000500040003000090004000403018608000000",
    s: "396784521451329786287165439963512847814637952572948163135896274729453618648271395",
    d: 54000000,
  },
  {
    p: "300020400001000050000600092049012703000040500000008010000900000500007000070804000",
    s: "397125468261489357854673192649512783183746529725398614432961875518237946976854231",
    d: 54000000,
  },
  {
    p: "002000000005000046700450800000300007340000060006005001020003090009170000000004200",
    s: "412698375985237146763451829591326487348719562276845931124563798839172654657984213",
    d: 54000000,
  },
  {
    p: "000009080726080000000000703000300010000012000001570060009000000007004600040020905",
    s: "413759286726483591895261743572346819684912357931578462269835174357194628148627935",
    d: 54000000,
  },
  {
    p: "400000020060315000000008501000842000800030104900100000100700908030000000000003400",
    s: "415697823268315749397428561571842396826539174943176285152764938734981652689253417",
    d: 54000000,
  },
  {
    p: "000000050070020000002700030060040200500009070090100000600004000000070008105060300",
    s: "416893752378425961952716834861347295524689173793152486687234519239571648145968327",
    d: 54000000,
  },
  {
    p: "000020000080034700003700100000000002500016000370000050000000001029300008000400609",
    s: "417625983986134725253798164698573412542816397371249856864957231729361548135482679",
    d: 54000000,
  },
  {
    p: "407900800300000901060080040000005004800000100601000700000078000700010620003020070",
    s: "417952836328746951569381247972165384834297165651834792296578413785413629143629578",
    d: 54000000,
  },
  {
    p: "410000260600080000000001050007100590200904130000830000000300005003000020700000004",
    s: "418573269635289471972461853347126598286954137591837642864392715153748926729615384",
    d: 54000000,
  },
  {
    p: "010760000200000400700001003350000009000000784008000000807050000060009000000180092",
    s: "419763258236598417785421963354876129621935784978214536897652341162349875543187692",
    d: 54000000,
  },
  {
    p: "019000032000410000000000504004000000070090020280100600007003200300000005502000063",
    s: "419865732753412986628379514934286157176594328285137649847653291361928475592741863",
    d: 54000000,
  },
  {
    p: "400360000500000000000100470800070003070618500000000040040089000709000005000000600",
    s: "421367958567894231938152476892475163374618529156923847643589712719246385285731694",
    d: 54000000,
  },
  {
    p: "403007900000240030000030000095010002000400003000020100200900860001000045006800000",
    s: "423587916618249537759136284895613472172498653364725198237954861981362745546871329",
    d: 54000000,
  },
  {
    p: "000000500065800071800600002001005300040102005006070000000500080002007000070000000",
    s: "423791568965823471817654932791485326348162795256379814139546287582917643674238159",
    d: 54000000,
  },
  {
    p: "400016700030007100000024603050700000160002005000900000600000000507000026098000000",
    s: "425316798836597142971824653354768219169432875782951364613249587547183926298675431",
    d: 54000000,
  },
  {
    p: "000000010003056004100200000000502000740000000001090060076901502004007800000800100",
    s: "425739618983156274167284359639572481748613925251498763876941532514327896392865147",
    d: 54000000,
  },
  {
    p: "020300000600020080001000900000476000000000000043200700205800070000000409070109600",
    s: "428391567639527184751648932512476893867913245943285716295864371186732459374159628",
    d: 54000000,
  },
  {
    p: "009000008706002940300000020040900700000000050000080201231500800000000007890006000",
    s: "429365178756812943318749625142953786683271459975684231231597864564128397897436512",
    d: 54000000,
  },
  {
    p: "000807000500009600000000020008020000000000370000510004006000250090052008030000001",
    s: "429867135513249687867135429948723516651984372372516894786491253194352768235678941",
    d: 54000000,
  },
  {
    p: "000502600007100030000000004004200800000806257050000000900000006026095300000000070",
    s: "431572689697184532582369714764253891319846257258917463975438126126795348843621975",
    d: 54000000,
  },
  {
    p: "000009008005000000700026003040080010006005000850701000007002569000000000604000070",
    s: "432179658965834127718526943249683715176295834853741296387412569591367482624958371",
    d: 54000000,
  },
  {
    p: "005000080009000002000095004001400000096012000000007810600040000004003005700000006",
    s: "435276981169834752287195364371458629896312547542967813653741298924683175718529436",
    d: 54000000,
  },
  {
    p: "400100057000090200090076000500040010200900500080000006000000020700260038000000005",
    s: "436128957857394261192576384579643812264981573381752496618435729745269138923817645",
    d: 54000000,
  },
  {
    p: "406100020002000010000003006000000093000001870000650000750008000601009702003000000",
    s: "436175928582946317917823456175482693264391875398657241759268134641539782823714569",
    d: 54000000,
  },
  {
    p: "407006000000035000010000030000000820082060000601300000000600049070900060800052000",
    s: "437296185268135794915874632359741826782569413641328957123687549574913268896452371",
    d: 54000000,
  },
  {
    p: "400070050000008000020000700780090000000020940600000000000000007090350001305006008",
    s: "438271659576938124921465783782694315153827946649513872264189537897352461315746298",
    d: 54000000,
  },
  {
    p: "400009008000700000038020460000070026040006000003000100006000504800000000010000230",
    s: "452639718961784352738521469185473926249156873673892145396217584827345691514968237",
    d: 54000000,
  },
  {
    p: "000001390000000000731020400800030005000000200105600000090005002067000000200090708",
    s: "452861397689473521731529486846932175973158264125647839398715642567284913214396758",
    d: 54000000,
  },
  {
    p: "400007000010059000000100007004003000205010000000060305500002010000900003600030890",
    s: "456327981317859246928146537764593128235718469189264375593682714842971653671435892",
    d: 54000000,
  },
  {
    p: "050090003000620500020000170800040060000000002000962030084010700039000000100400000",
    s: "456791283317628594928534176872143965693857412541962837284316759739285641165479328",
    d: 54000000,
  },
  {
    p: "000900103020000000070043009005000301000000000100050078000370900700600500260000000",
    s: "456927183329816754871543269945768321687231495132459678518372946793684512264195837",
    d: 54000000,
  },
  {
    p: "000007063600900001102400000003001000000004700006000085920010000000005000000003570",
    s: "459187263678932451132456897593871624281564739746329185925718346367245918814693572",
    d: 54000000,
  },
  {
    p: "450007010000000009008090000006000000800003507070100803005600300300708040000300000",
    s: "459237618123486759768591432936875124814923567572164893285649371391758246647312985",
    d: 54000000,
  },
  {
    p: "009200003800000000700065040000000054000700960000850000308002009020000000600007001",
    s: "459278613862413795731965248973126854185734962246859137318642579527391486694587321",
    d: 54000000,
  },
  {
    p: "000000003006200000070000100018060000000008005090000032007006080203000007001800040",
    s: "459681723136275498872493156318562974724938615695714832947356281283149567561827349",
    d: 54000000,
  },
  {
    p: "000008000308000020000000306070400010009302000050070008530090000012000005004600001",
    s: "461238579398567124725914386876459213149382657253176948537891462612743895984625731",
    d: 54000000,
  },
  {
    p: "401008050008604002000000006000200530000501000017030080230007000006800000005000000",
    s: "461728953358694712792315846684279531923581674517436289239157468176842395845963127",
    d: 54000000,
  },
  {
    p: "000100300000002064000603000607090000980070002004000100008000040200009005009004010",
    s: "462157398371982564895643721617295483983471652524368179138526947246719835759834216",
    d: 54000000,
  },
  {
    p: "402000708500790300300000000005000000900100000000800004007280000004035020000000069",
    s: "462513798518792346379648512825364971946157283731829654197286435684935127253471869",
    d: 54000000,
  },
  {
    p: "000000100000230060020000080000090007304001008001063005000040700109000000086005000",
    s: "463589172817234569925176483658492317394751628271863945532648791149327856786915234",
    d: 54000000,
  },
  {
    p: "060780020000000030000013040005070000300200007900400006000900100002000000084000300",
    s: "463789521851642739729513648245876913316295487978431256537928164192364875684157392",
    d: 54000000,
  },
  {
    p: "060000820000000000000846000030900040200700006908000700010000390004050000690003480",
    s: "465397821879521634123846579736915248241738956958462713517684392384259167692173485",
    d: 54000000,
  },
  {
    p: "060810000090000620100300040000480000000000280608000009000600004970000000054000300",
    s: "465812937893547621127396548732489165549761283618253479381625794976134852254978316",
    d: 54000000,
  },
  {
    p: "000009000052600390030500600016040009004050000000000002040080056800200001000003000",
    s: "467139825152678394938524617716342589294851763583796142341987256879265431625413978",
    d: 54000000,
  },
  {
    p: "007008000000000630098002700906700000080000900000001470050000010070630500009000000",
    s: "467358192215974638398162745946723851781546923523891476654287319172639584839415267",
    d: 54000000,
  },
  {
    p: "460010000000000004290000050000769100050000008009003000003090000000400032900008700",
    s: "468315279375982614291647853834769125657124398129853467743296581586471932912538746",
    d: 54000000,
  },
  {
    p: "400053200003006100080000650200081000006000000317620000000010500000502400000090060",
    s: "469153278523876194781249653295781346846935721317624985672418539938562417154397862",
    d: 54000000,
  },
  {
    p: "000020807200005000071009400000014600008006004000900020006400190000030000000100000",
    s: "469321857283745961571869432732514689958276314614983725826457193197632548345198276",
    d: 54000000,
  },
  {
    p: "000000010070600005050807430601005000008000061024360000000000300040000092007103000",
    s: "469532817873614925152897436691285743538479261724361589215946378346758192987123654",
    d: 54000000,
  },
  {
    p: "001200009000040070005000000063020100002003000000060040010080300208030600009000050",
    s: "471256839926348571385197426563924187142873965897561243714685392258739614639412758",
    d: 54000000,
  },
  {
    p: "070000000000200630000009104090001850005000000304020006900030000100040000600095400",
    s: "471386925589214637236759184792461853865973241314528796948637512157842369623195478",
    d: 54000000,
  },
  {
    p: "000000000030700520905000000693200080708100000050009000007405090000000302000327008",
    s: "472538916836791524915642837693274185748153269251869743327485691584916372169327458",
    d: 54000000,
  },
  {
    p: "002000300009000000005064089600500200001000005200000670180070090000148000000000060",
    s: "472981356869753124315264789694537218731826945258419673183675492926148537547392861",
    d: 54000000,
  },
  {
    p: "002900000000140007900000000021050000050400200000009630064070000100000000003060540",
    s: "472983156538146927916725384321658479659437218847219635264571893185394762793862541",
    d: 54000000,
  },
  {
    p: "003000900210030000000700480030010000002906000004000000000060300700500014000000097",
    s: "473658921218439576965721483637815249182946735594372168849167352726593814351284697",
    d: 54000000,
  },
  {
    p: "470000000900000600000600180000000000100054030000803009040000005708100000009030040",
    s: "476381592981425673235697184893276451167954238524813769342768915758149326619532847",
    d: 54000000,
  },
  {
    p: "000000060100060800320700000080000104700010203000000700900005400000034000004970001",
    s: "478591362159362847326748915683257194745619283291483756967125438512834679834976521",
    d: 54000000,
  },
  {
    p: "008000001509703008000004000705000016000050409000070500020309060300000000800200900",
    s: "478625391569713248213894657745932816632158479981476523124389765396547182857261934",
    d: 54000000,
  },
  {
    p: "000000356002005004380060009230800400000000000010027090040050000601000000007000060",
    s: "479182356162935784385764219236819475798546132514327698943651827651278943827493561",
    d: 54000000,
  },
  {
    p: "080500620296000005070008010000000004000000006000814070008309000060700090050000002",
    s: "481593627296471835573268419937652184814937256625814973748329561162745398359186742",
    d: 54000000,
  },
  {
    p: "000006020030000100096750030070000049000080201002040070000400000068100002100000000",
    s: "481936725537824196296751834873612549954387261612549378325468917768193452149275683",
    d: 54000000,
  },
  {
    p: "080090050030600000000400309908006000000000506640000097094000070360780004000001000",
    s: "482397651539612748716458329958176432271934586643825197194263875365789214827541963",
    d: 54000000,
  },
  {
    p: "002000007060019000090000000500000070008056093000000802016802000030000000000060008",
    s: "482635917765219384391487526549328671128756493673194852916842735834571269257963148",
    d: 54000000,
  },
  {
    p: "080010000009204007005908000100000005007000003000100840000470520000006030000090006",
    s: "482713659619254387375968214138642795247589163596137842963471528754826931821395476",
    d: 54000000,
  },
  {
    p: "080000900000060007032800010000500040000400089904006205000001008200605000050000390",
    s: "486217953519364827732859416863592741125473689974186235347921568298635174651748392",
    d: 54000000,
  },
  {
    p: "006007500070000000002040090007830006005000140000600000200000600030000009794000301",
    s: "486297513973158462512346897147835926365729148829614735251983674638471259794562381",
    d: 54000000,
  },
  {
    p: "000026109930080207000000000140305000390200400000000000204000080000700000000030016",
    s: "487526139935184267621973845142395678398267451756841392214659783563718924879432516",
    d: 54000000,
  },
  {
    p: "090280000080400000000001040003000491709000050600050000006100020000042700500060009",
    s: "491283576385476912267591348853627491729814653614359287976135824138942765542768139",
    d: 54000000,
  },
  {
    p: "000307000020004000000069014100700590730080000008000407000000050000090300060001002",
    s: "491327865826154973375869214142736598739485621658912437284673159517298346963541782",
    d: 54000000,
  },
  {
    p: "401075002030000000000032000200000500716000200000080010009008700000007005060090300",
    s: "491675832532841976678932451283716549716459283945283617359128764824367195167594328",
    d: 54000000,
  },
  {
    p: "000000600065002000710004900000040207008600001030087000000000000000703109900050000",
    s: "492178653865932714713564928659341287278695431134287596327419865586723149941856372",
    d: 54000000,
  },
  {
    p: "400000600000000250100607000000100040300060810700890020004002009601900000070000000",
    s: "492581673867349251135627498258173946349265817716894325584732169621958734973416582",
    d: 54000000,
  },
  {
    p: "002070100000000009000309800100002070006000004040006008380120040700500000200030000",
    s: "492875163873261459615349827138452976926783514547916238389127645761594382254638791",
    d: 54000000,
  },
  {
    p: "003000002050300060000000490004006010009000500000520000008002047100008000000400800",
    s: "493687152251394768867215493584736219329841576716529384638152947142978635975463821",
    d: 54000000,
  },
  {
    p: "090000080023040000000000240000000670206970005004500008850000107000000000600120003",
    s: "495217386123648759768359241519834672286971435374562918852493167931786524647125893",
    d: 54000000,
  },
  {
    p: "400000300200070001017500000040050000300461000000000023008000070000006000500200810",
    s: "496128357235674981817593246749352168382461795651789423128935674974816532563247819",
    d: 54000000,
  },
  {
    p: "400000000000900600000405910000097060710080205082500000000000007320000001000003040",
    s: "496318752135972684278465913543297168719684235682531479864159327327846591951723846",
    d: 54000000,
  },
  {
    p: "000326180001090000000000003070005610000000029050041007604050002000060000083000000",
    s: "497326185231598746865714293372985614148637529956241837614859372729163458583472961",
    d: 54000000,
  },
  {
    p: "000500801000010700000700030904300000000021003060070000000080070150000000603140000",
    s: "497532861836914752521768439914356287785421693362879514249683175158297346673145928",
    d: 54000000,
  },
  {
    p: "008200000300915000060000270007006105000000007000050090920001008600030001080000000",
    s: "498267513372915864165483279247396185539128647816754392923671458654839721781542936",
    d: 54000000,
  },
  {
    p: "008007001000100070000002430800436009350010020600000000003040000000900050067000000",
    s: "498357261235164978716892435872436519359718624641529387583641792124973856967285143",
    d: 54000000,
  },
  {
    p: "000500070002080400000709000600000250003000008700030610040060000035100000100490020",
    s: "498512376572386491316749582681974253923651748754238619249865137835127964167493825",
    d: 54000000,
  },
  {
    p: "098030000006280005003070000057008903800090200000005060000007002000000009000640100",
    s: "498536721716284395523179486257468913864391257139725864381957642642813579975642138",
    d: 54000000,
  },
  {
    p: "500400000060000005007065030000040000004900387020070509340000000901000802000200000",
    s: "513492678468731925297865134739548216154926387826173549342689751971354862685217493",
    d: 54000000,
  },
  {
    p: "500006000062005004400003007000000075206000900075090030000000790009017000020300046",
    s: "513746829762985314498123567984231675236574981175698432351462798649817253827359146",
    d: 54000000,
  },
  {
    p: "000000008070940050090051270400102800008700000001090000040009000000400906260000700",
    s: "514273698872946153396851274457132869928764315631598427743619582185427936269385741",
    d: 54000000,
  },
  {
    p: "010003000060002000008040300800000019600050400003701050900000000070000500000035100",
    s: "514673928369812745728549361857364219691258437243791856935127684172486593486935172",
    d: 54000000,
  },
  {
    p: "010090070200003000800604002000730010080000094005000206020001009009060000000000001",
    s: "514892673267153948893674152642739815381526794975418236728341569139265487456987321",
    d: 54000000,
  },
  {
    p: "500000000008000040400070010000030250002009001850204030790000560200000000000406009",
    s: "516342897978165342423978615149637258632589471857214936794821563265793184381456729",
    d: 54000000,
  },
  {
    p: "010300006008140005000000000006053080000007090400600000700000008009000001000005362",
    s: "517389426968142735342576819276953184851427693493618257735261948629834571184795362",
    d: 54000000,
  },
  {
    p: "507000008006040007093700000000307050030020000002001800000000010100400090904003000",
    s: "517932468286145937493768521641387259839524176752691843325879614178456392964213785",
    d: 54000000,
  },
  {
    p: "000070003402000070090304100000926000000000000900840056050003090006000000200010040",
    s: "518279463432168975697354128175926834864537219923841756751483692346792581289615347",
    d: 54000000,
  },
  {
    p: "000600003006400001080903000003070000160000200090100007000025608002000700000000130",
    s: "519682473326457891784913526843276915167539284295148367971325648432861759658794132",
    d: 54000000,
  },
  {
    p: "510003400000000091000007036001000057000094000090008604800070000006300000034060005",
    s: "519683472763542891248917536481236957657194283392758614825471369976325148134869725",
    d: 54000000,
  },
  {
    p: "000830000070000010004050000090000240600200000000070053703100008810003900400008000",
    s: "521837694376492815984651372197385246635214789248976153753169428812543967469728531",
    d: 54000000,
  },
  {
    p: "020940000017020600000000090005000300300002005000000010100060900200500401800003050",
    s: "523946178917825643468137592795681324341792865682354719154268937236579481879413256",
    d: 54000000,
  },
  {
    p: "000060104000200000076050000700008000050000026030000090380000500000000400100409000",
    s: "523967184941283657876154932712698345459371826638542791384726519297815463165439278",
    d: 54000000,
  },
  {
    p: "520000000000763000000010009410000800007000100305000090000000527100500003000807001",
    s: "523984716941763258768215349412396875697458132385172694839641527176529483254837961",
    d: 54000000,
  },
  {
    p: "004600007001080400090070005000000103007020040000760500010308009039000600000000000",
    s: "524631897371985462698472315962854173857123946143769528716348259239517684485296731",
    d: 54000000,
  },
  {
    p: "520000000000210050070000900053000000000000004004060309800001000030004670900035100",
    s: "526497831498213756371856942653149287219378564784562319865721493132984675947635128",
    d: 54000000,
  },
  {
    p: "500040130180000007000006800000000006760050040000107000403900500000000000000003080",
    s: "526748139184392657937516824295834716761259348348167295473981562819625473652473981",
    d: 54000000,
  },
  {
    p: "500000046000706000308400002706000000081000003000075900070060300040380000000000020",
    s: "527938146419726835368451792756193284981642573234875961875264319142389657693517428",
    d: 54000000,
  },
  {
    p: "500700406400002079600000005790200600040005000000030004000010000005300800000906007",
    s: "529781436438562179617493285791248653243675918856139724364817592975324861182956347",
    d: 54000000,
  },
  {
    p: "020060000000903800700400090000000052007080930600007400000508000402000000006040500",
    s: "529861347164973825738452691381694752247185936695327418973518264452736189816249573",
    d: 54000000,
  },
  {
    p: "001046000006300000000000305000031002009800000000090450450012000108070000000000004",
    s: "531746298926385147874129365745631982219854673683297451457912836168473529392568714",
    d: 54000000,
  },
  {
    p: "000702080000000900490500000270350010005004000009000870000800040000060300003007001",
    s: "531792684628413957497586132276358419185974263349621875912835746754169328863247591",
    d: 54000000,
  },
  {
    p: "000007024006500000080000000000060007053700000070140000360000050010800070000003209",
    s: "531987624496521738287436915124365897653798142879142563368279451912854376745613289",
    d: 54000000,
  },
  {
    p: "000009000000573800900004003001300005060010000300008100000800960000000300490005020",
    s: "532189647614573892987264513741396285865712439329458176153827964276941358498635721",
    d: 54000000,
  },
  {
    p: "000000700001000050902000040600820090010050807400000002000069008006010000070000013",
    s: "534192786781436259962587341657823194213954867498671532125369478346718925879245613",
    d: 54000000,
  },
  {
    p: "500800600016034007000002000070253004360700000000600000000000870000000045003010000",
    s: "534897612216534987897162453978253164361749528425681739649325871182976345753418296",
    d: 54000000,
  },
  {
    p: "006002900000005030700000100000008000050030009007200006300689000002000080005001400",
    s: "536172948149865732728493165263918574451736829897254316374689251912547683685321497",
    d: 54000000,
  },
  {
    p: "030100009000050000000800050400000000002900700710060040040320680903000007050000000",
    s: "536174829891652374274893156465731298382945761719268543147329685923586417658417932",
    d: 54000000,
  },
  {
    p: "000108002002005100080400903000700000653000000018000004020060500000007401000004060",
    s: "536198742942375186187426953294783615653941278718652394421869537869537421375214869",
    d: 54000000,
  },
  {
    p: "030000402071000008890000030008000910000009000000350740083000000700000504100607000",
    s: "536781492271934658894562137458276913367149825912358746683495271729813564145627389",
    d: 54000000,
  },
  {
    p: "000000400900100300006090008005306002000000000703005100000500000120000700300600010",
    s: "537268491982154367416793528845316972291847635763925184679581243128439756354672819",
    d: 54000000,
  },
  {
    p: "000402061000000090460080030000200980000004102095700000050006000003000004001070000",
    s: "538492761127653498469187235314265987876934152295718346752346819983521674641879523",
    d: 54000000,
  },
  {
    p: "500000040007000035006905000090000000050028070000003006020040007001007200300800100",
    s: "538716942917284635246935781694571823153628479782493516825149367461357298379862154",
    d: 54000000,
  },
  {
    p: "030000000000806000000500780007000306000080129000205000310000007090310060005000200",
    s: "538971642174826935629543781287194356453687129961235478316452897792318564845769213",
    d: 54000000,
  },
  {
    p: "000000608008500047000030005004000500091800000000070106000900064320000000900000200",
    s: "539147628618592347472638915764319582291856473853274196185923764327461859946785231",
    d: 54000000,
  },
  {
    p: "000008460700000090000006001006407500000030900800500000900060010020105000008000070",
    s: "539718462761254398482396751196487523245631987873529146957863214624175839318942675",
    d: 54000000,
  },
  {
    p: "000000007603040000080009040900402000016300005400000100104080000000506000050000200",
    s: "541823967693741852782659341935412678216378495478965123164287539829536714357194286",
    d: 54000000,
  },
  {
    p: "000009000068000900000420850600004180070102540100500007030000400010030000007008000",
    s: "541879632268351974793426851652794183379182546184563297835217469416935728927648315",
    d: 54000000,
  },
  {
    p: "000006000100000005080020010000050700020190340000000000001700406004902000900060007",
    s: "542816973196374825387529614413258769625197348879643152231785496764932581958461237",
    d: 54000000,
  },
  {
    p: "500009000016080094000040002400305709060000000009000040000050020080007000002000630",
    s: "543129876216783594897546312428315769165974283379862145931658427684237951752491638",
    d: 54000000,
  },
  {
    p: "003000010000563000086200000008010050070390060000052107020000034300000000054000000",
    s: "543879216912563748786241593268714359175398462439652187627185934391426875854937621",
    d: 54000000,
  },
  {
    p: "500020090020300460070060000000008000680510002000000100004035000000000003860000001",
    s: "546821397921357468378469215137298654689514732452673189794135826215786943863942571",
    d: 54000000,
  },
  {
    p: "500000008010050900009682000900300000060005209800100064005003100700000000600010007",
    s: "546931728218457936379682541924376815163845279857129364495763182781294653632518497",
    d: 54000000,
  },
  {
    p: "540006000060000002010590004009007000000001059700320000000000010020008030000010427",
    s: "547286391963174582812593674189457263234861759756329148475932816621748935398615427",
    d: 54000000,
  },
  {
    p: "000600031030000020109500000000310406080026000070000000004080600800060070000005900",
    s: "547692831638741529129538764952317486481926357376854192794283615815469273263175948",
    d: 54000000,
  },
  {
    p: "040003000603400080200007000000000109001500000370000046000100900020748300000000470",
    s: "547823691613459287289617534862374159491586723375291846754132968926748315138965472",
    d: 54000000,
  },
  {
    p: "508710006006009007000000000200000800001200063000968000900540178000003040050000000",
    s: "548712396316489527792635481269371854871254963435968712923546178687193245154827639",
    d: 54000000,
  },
  {
    p: "500000090000000764000310500000000000004290600007500020310080400000000006060003100",
    s: "548762391123958764976314582251836947834297615697541823312685479485179236769423158",
    d: 54000000,
  },
  {
    p: "000300000700600000020000100008900040040008007000005000692000070000500608030001200",
    s: "561324789783619425924857163158976342246138957379245816692483571417592638835761294",
    d: 54000000,
  },
  {
    p: "061040070000609000400000230000000400000937008907000020206150000050800000000000010",
    s: "561342879732689541498571236315268497624937158987415623276153984153894762849726315",
    d: 54000000,
  },
  {
    p: "060000040004070000000002080090000103700000000800605002007504008100800094000001000",
    s: "561389247284176935379452681692748153745213869813695472927564318136827594458931726",
    d: 54000000,
  },
  {
    p: "000001000470000180030090042000009015020030000700050829000000600004000000090845000",
    s: "562481973479523186831796542648279315925138467713654829387912654154367298296845731",
    d: 54000000,
  },
  {
    p: "000001070104000009098000400000407020200010005000050007000000030009805000430000900",
    s: "562941873174583269398726451953467128247318695816259347781694532629835714435172986",
    d: 54000000,
  },
  {
    p: "000800000000106040720000800600000000053062009079350000080000050007009004100038090",
    s: "564873921398126547721495836612984375853762419479351268986247153237519684145638792",
    d: 54000000,
  },
  {
    p: "000020301700008005400000820000000053036000200000910700000190000070802000005000030",
    s: "568429371721368495493751826987246153136587249254913768342195687679832514815674932",
    d: 54000000,
  },
  {
    p: "060074200000100000400008000050080400900040028030050001002003007640000000005200000",
    s: "568974213729136845413528769251789436976341528834652971182493657647815392395267184",
    d: 54000000,
  },
  {
    p: "000800030700600001000030508006009070305040000000000190012000600000000703000405000",
    s: "569812437783654921241937568126589374395741286874263195412378659958126743637495812",
    d: 54000000,
  },
  {
    p: "069800070020600005000010040003500100050092680040006000900003450034000900000000000",
    s: "569824371421637895378915246693548127157392684842176539916783452734251968285469713",
    d: 54000000,
  },
  {
    p: "000023800000400000026000030100800004000000500807010002000604000350000007010035000",
    s: "571923846983456271426178935135862794269347518847519362792684153354291687618735429",
    d: 54000000,
  },
  {
    p: "000006200008030100604209080207503900006001000000000070000902005005007600090000000",
    s: "573186294928435167614279583247563918836791452159824376761942835485317629392658741",
    d: 54000000,
  },
  {
    p: "003420096000070004000060300007900000300000012004000000001700040000600020086043000",
    s: "573428196618379254492165387127934568369857412854216739931782645745691823286543971",
    d: 54000000,
  },
  {
    p: "000380006000090400000010350190060000407200080000001000000000070036400009080006040",
    s: "574382196613597428829614357192768534467253981358941762241839675736425819985176243",
    d: 54000000,
  },
  {
    p: "000600020010005000009007006900803000000050987062000000025000100003100064000000000",
    s: "574689321618325749239417856957843612341256987862971435425768193783192564196534278",
    d: 54000000,
  },
  {
    p: "500600003000407900001800000406000000090050200000003009200080001300000805000060320",
    s: "574692183638417952921835476416928537793156248852743619265384791349271865187569324",
    d: 54000000,
  },
  {
    p: "070000308009040000002000506610000000000003600004901000000709003000430205800506000",
    s: "576192348389645721142387596617854932958273614234961857465729183791438265823516479",
    d: 54000000,
  },
  {
    p: "000020003010007060328000000030204070000060000200900610000100040007000900090080050",
    s: "576429183914837562328651497639214875741568239285973614853192746167345928492786351",
    d: 54000000,
  },
  {
    p: "000820419000006000003010000050004980000000000010008520004000000720400850000072340",
    s: "576823419981746235243519678352164987498257163617398524134685792729431856865972341",
    d: 54000000,
  },
  {
    p: "078036009900000003400000020004001200001005030050070008000000501090000000032084000",
    s: "578236419926148753413759826384961275761825934259473168647392581895617342132584697",
    d: 54000000,
  },
  {
    p: "008030400300000000001008905000700090800503020042000600000050000000602001950007000",
    s: "578239416394165782621478935135726894869543127742981653217854369483692571956317248",
    d: 54000000,
  },
  {
    p: "000042100006010000030005007020008730080000204305000000000024000000001058009000070",
    s: "578342169296817543134695827921468735687153294345279681853724916762931458419586372",
    d: 54000000,
  },
  {
    p: "000004001000700564003000000006500008300008020002300050040002000000000910807010000",
    s: "579264381128793564463851792716529438354178629982346157641932875235487916897615243",
    d: 54000000,
  },
  {
    p: "570020000003000010000930007091600000800005004000100000020000430000004026010200000",
    s: "579821643263457819148936257491683572832795164657142398926578431785314926314269785",
    d: 54000000,
  },
  {
    p: "079030000000001082000007009800900400604008100000005000006000000940000026010000005",
    s: "579832614463591782128467539832916457654728193791345268386254971945173826217689345",
    d: 54000000,
  },
  {
    p: "580002006000700000049000000007000492000008000400001060000035800300600000020000010",
    s: "581392746236754981749186235817563492693428157452971368164235879378619524925847613",
    d: 54000000,
  },
  {
    p: "001000000000006908062000051100487000000000090200030700600208005700001000040090000",
    s: "581924637437516928962873451193487562874652193256139784619248375725361849348795216",
    d: 54000000,
  },
  {
    p: "502090700040000001000000900050000000007006050600040003030710600005000038400060000",
    s: "582193764946257381173684925354972816217836459698541273839715642765429138421368597",
    d: 54000000,
  },
  {
    p: "000000090003050002910086040300400000020000130809000000056000000000063000000008075",
    s: "582314796463957812917286543371425968625879134849631257156742389798563421234198675",
    d: 54000000,
  },
  {
    p: "080000910040057008006001000000003000003504720704000001800000100000000052020700300",
    s: "582436917341957268976821543268173495193584726754269831835642179417398652629715384",
    d: 54000000,
  },
  {
    p: "080000000160300002700005008050007400000052009600000003005700300000100090910040600",
    s: "582471936164389572739265148258937461341652789697814253825796314476123895913548627",
    d: 54000000,
  },
  {
    p: "080703000006000000100490200200005103091000820003000006409051000000000000000900070",
    s: "582713964946582317137496258264875193791634825853129746479351682618247539325968471",
    d: 54000000,
  },
  {
    p: "000000000093006701001000009000308000320609000005000040200100006000065480800003000",
    s: "582971634493826751671534829147358962328649175965712348234187596719265483856493217",
    d: 54000000,
  },
  {
    p: "000001000036800000200040800000600180807000000009470002300100400000090500002700090",
    s: "584231769936857214271946835453629187827513946619478352395162478768394521142785693",
    d: 54000000,
  },
  {
    p: "080093000007000080000020060070000009002000607900400100054700300200300000010005040",
    s: "586193274327654981491827563678231459142589637935476128854712396269348715713965842",
    d: 54000000,
  },
  {
    p: "000200700000005060009000305000010200000530006000706043032080001708020000090000600",
    s: "586243719321975468479168325963814257847532196215796843632489571758621934194357682",
    d: 54000000,
  },
  {
    p: "080010003210000000000306000690020080070004020804000090000203050000000400100090008",
    s: "586712943213849576749356812691527384375984621824631795468273159952168437137495268",
    d: 54000000,
  },
  {
    p: "500010903040060205000050000000000002160200000078600004030700100009008506000000000",
    s: "587412963341967285692853741954381672163274859278695314435726198729148536816539427",
    d: 54000000,
  },
  {
    p: "000900000630018007000570080010080060402000000860007000050003700004000013006000400",
    s: "587934126639218547241576389713489265492365871865127934158643792974852613326791458",
    d: 54000000,
  },
  {
    p: "009610000000307250020000910902008370001009060000000000040000000000800003010003400",
    s: "589612734164397258327584916952468371431759862678231549843125697795846123216973485",
    d: 54000000,
  },
  {
    p: "090007030004000000008000605000090050002004007000000003010025076080010000300900200",
    s: "591267834634589721728431695173698452962354187845172963419825376286713549357946218",
    d: 54000000,
  },
  {
    p: "500000008004087200020001000000000724400090000016005000140000000070200060300010900",
    s: "591423678634987215728651349953168724487392156216745893149876532875239461362514987",
    d: 54000000,
  },
  {
    p: "001000070000500001620900004010000300000680005007090060002000000008000030030010407",
    s: "591468273784532691623971584816725349249683715357194862162347958478259136935816427",
    d: 54000000,
  },
  {
    p: "000000307102000000000705012009400080000680100000000400000802004080003006740000000",
    s: "596218347172934658438765912619457283324689175857321469961872534285143796743596821",
    d: 54000000,
  },
  {
    p: "506000000000702004000000301800006000700520000004080700200000530009041008000000000",
    s: "596314287138752964472698351825476193713529846964183725241867539359241678687935412",
    d: 54000000,
  },
  {
    p: "006040710000000000000001053080009000020064000000008400007500001109000800038000062",
    s: "596342718813675294742891653384259176921764385675138429267583941159426837438917562",
    d: 54000000,
  },
  {
    p: "000000203000056000040000008002100060005300000009780000050000090027509400000008370",
    s: "596871243283456719741923658432195867875364921619782534358647192127539486964218375",
    d: 54000000,
  },
  {
    p: "000001040000080090200906300070403000000000008030050002900300005320000000780109000",
    s: "597231846613584297248976351872413569156792438439658712964327185321865974785149623",
    d: 54000000,
  },
  {
    p: "590000000020060003000080904013009400000508100050000000300000700000210309000007010",
    s: "597432861824961573136785924213679485479528136658143297361894752785216349942357618",
    d: 54000000,
  },
  {
    p: "000008100000000050083050900000570020005840300200001006804000007970000030000200000",
    s: "597628143426319758183754962319576824765842319248931576854163297972485631631297485",
    d: 54000000,
  },
  {
    p: "008240000710600000002100005004010038000000070100070000900000500000002090006580003",
    s: "598243167713658249642197385274915638865324971139876452987431526351762894426589713",
    d: 54000000,
  },
  {
    p: "000000030010400800030008050000006910002000070800900002780200000600000500000037600",
    s: "598612734217453896436798251374526918962381475851974362789265143623149587145837629",
    d: 54000000,
  },
  {
    p: "090021006000000570301600000056000904000002000000090100800007000000540009004010005",
    s: "598721436462389571371654298156873924749162853283495167815937642627548319934216785",
    d: 54000000,
  },
  {
    p: "590000000000530070000006500000000030650010204084000001030020010040900802000067000",
    s: "598741326462538179173296548219485637657319284384672951936824715741953862825167493",
    d: 54000000,
  },
  {
    p: "600080900400001050000000000090004582000000000000390060080450007504006010070003000",
    s: "613285974429731856758649123397164582861527439245398761186452397534976218972813645",
    d: 54000000,
  },
  {
    p: "000035007930000600000000000000462000201003860003080009070600002100000090450008100",
    s: "614235987932847651587196234895462713241973865763581429378619542126754398459328176",
    d: 54000000,
  },
  {
    p: "600380700005001000008050000040603000300018040800002007002060800000000270401000600",
    s: "614389725935721468278456193149673582327518946856942317792165834563894271481237659",
    d: 54000000,
  },
  {
    p: "000900007000000160230000904062080000000203040500000870009050036800020000007001000",
    s: "614938527978542163235176984462785319781293645593614872129857436846329751357461298",
    d: 54000000,
  },
  {
    p: "000000090000650210200000060701060000500308007083010000006009008000120500000700000",
    s: "615842793978653214234971865791465382562398147483217956126539478847126539359784621",
    d: 54000000,
  },
  {
    p: "010000000900001706002000009200040080097000600400703000703005100050690003000000000",
    s: "615879342948231756372564819231946587597182634486753921763425198154698273829317465",
    d: 54000000,
  },
  {
    p: "017008000900100420240000000090000007000064009000000800008401050000800000106030000",
    s: "617248593985173426243659718594382167871564239362917845738491652459826371126735984",
    d: 54000000,
  },
  {
    p: "007000309020700050000400002800031000040000010000000200006000005400800007300040060",
    s: "617582349924763851538419672865231794243978516791654283186397425459826137372145968",
    d: 54000000,
  },
  {
    p: "000900042030000000009500001400003000080000750090052000002000013807000000000026400",
    s: "618937542534261978729548631475683129283194756196752384962475813847319265351826497",
    d: 54000000,
  },
  {
    p: "618000200000000000004650709100080000000120005070000000080043007900010080000000600",
    s: "618974253597231468324658719132485976869127345475369821286543197943716582751892634",
    d: 54000000,
  },
  {
    p: "001050740008100002040020000900000076000080200000007410075309000000000130006001000",
    s: "621853749738194562549726381953412876417685293862937415175349628294568137386271954",
    d: 54000000,
  },
  {
    p: "600004500000000030000790862750600000009000000810520000001000000290460000006000085",
    s: "623184579987256431145793862752639148369841257814527396531978624298465713476312985",
    d: 54000000,
  },
  {
    p: "020000000000000209000003067003010490590348000800200000001000005086000040000701000",
    s: "625179384378654219149823567263517498597348621814296753931462875786935142452781936",
    d: 54000000,
  },
  {
    p: "020800030008000006049000700060002508000030012000000400006780000050020000002413000",
    s: "625871934178394256349256781963142578584937612217568493436785129851629347792413865",
    d: 54000000,
  },
  {
    p: "020800003010000007000100800705000900000300200034070005000051006900000000002080700",
    s: "627894513819523647543167829785612934196345278234978165478251396951736482362489751",
    d: 54000000,
  },
  {
    p: "020000700000300600100057000056800207040000000070060010015000002000020180300400000",
    s: "628194753597382641134657928956841237241735896873269415415978362769523184382416579",
    d: 54000000,
  },
  {
    p: "608400090000020700000000004031000002000050069000004500004000000903500208050000300",
    s: "628437195415629783397185624531968472742351869869274531284713956973546218156892347",
    d: 54000000,
  },
  {
    p: "000500000091000048030000905070061000900470010003250000000100703000000050064300800",
    s: "628594137591637248437812965275961384986473512143258679859146723312789456764325891",
    d: 54000000,
  },
  {
    p: "000070000050200607001690000080006410000000005320001000009060050003500004000080170",
    s: "632478591958213647471695328587936412196842735324751986849167253713529864265384179",
    d: 54000000,
  },
];
